var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnTokenUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 96 96",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48,87c-21.537,0-39-17.46-39-39s17.463-39 39-39c21.54,0 39,17.46 39,39s-17.46,39-39,39zm0-9c6.633,0 12.747-2.181 17.715-5.823l-41.889-41.886c-3.648,4.965-5.826,11.076-5.826,17.709 0,16.566 13.431,30 30,30zm0-60c-6.684,0-12.837,2.211-17.823,5.91l41.913,41.916c3.696-4.989 5.91-11.139 5.91-17.826 0-16.569-13.431-30-30-30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnTokenUser);
export default __webpack_public_path__ + "static/media/return_token_user.45dca5266a927d2647d2d4c2fe269e2f.svg";
export { ForwardRef as ReactComponent };